import RegisteredVehicleTextRestModel from "@/models/rest/map/registeredVehicleTextRestModel";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { ContractorTypes } from "../../../models/emums/contractorTypes";

@Component
export default class RegisteredVehicleDialog extends Vue {
    @Prop({ type: Boolean, required: true })
    value!: boolean;

    contractorSearch = "";
    registeredVehicleTextModel = {} as RegisteredVehicleTextRestModel;

    get isLoading(): boolean {
        return this.$store.direct.state.loading;
    }

    get contractorFound() {
        return this.$store.direct.state.common.contractorSearch;
    }

    @Watch("value")
    onDialogValueChange(val: boolean) {
        if (val) {
            this.$nextTick(() => {
                this.resetForm();
            });
        }
    }

    @Watch("contractorSearch")
    contractorSearchLoadItems(val: string) {
        this.$store.direct.dispatch.common.searchContractors({ searchText: val, contractorTypes: [ContractorTypes.Carrier], contractorPropertiesEnabled: [], source: "" });
    }

    closeDialog() {
        this.$emit('input', false);
    }

    async processRegisteredVehiclesText() {
        const form = this.$refs.registeredVehicleForm as Vue & { validate: () => boolean, reset: () => void };
        if (!form.validate()) {
            return;
        }

        try {
            const result = await this.$store.direct.dispatch.vehicle.processRegisteredVehiclesText({ registeredVehicleTextModel: this.registeredVehicleTextModel }) as any;

            if (!result.isSuccess) {
                this.$store.direct.dispatch.vehicle.showVehicleMapInfoDialog({ showDialog: true, message: result.errorMessage, color: "error" });
            }
            else {
                this.$store.direct.dispatch.vehicle.showVehicleMapInfoDialog({ showDialog: true, message: result.errorMessage, color: "success" });
                this.resetForm();
            }
        } catch (error) {
            this.$store.direct.dispatch.vehicle.showVehicleMapInfoDialog({ showDialog: true, message: this.$t('common.errorOccurred').toString(), color: "error" });
        }
    }

    resetForm() {
        const form = this.$refs.registeredVehicleForm as Vue & { reset: () => void };
        form.reset();

        this.registeredVehicleTextModel = {} as RegisteredVehicleTextRestModel;
    }
}